"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsolePrompt = void 0;
const readline = __importStar(require("readline"));
class ConsolePrompt {
    static GET(question, options) {
        const rl = readline.createInterface({
            input: process.stdin,
            output: process.stdout
        });
        return new Promise(async (resolve) => {
            const answers = options.buttonLabels;
            const replyString = "(" + answers.join("|") + "):";
            question = question + " " + replyString;
            const doPrompt = async () => {
                rl.question(question, (input) => {
                    const res = options.validAnswers[input.toLowerCase()];
                    if (res === undefined) {
                        console.log("\"" + input + "\" is not a valid option. Use: " + replyString);
                        return doPrompt();
                    }
                    else {
                        rl.close();
                        return resolve(res);
                    }
                });
            };
            await doPrompt();
        });
    }
}
exports.ConsolePrompt = ConsolePrompt;
